import React from 'react';
import clsx from 'clsx';
import ACHPaymentField, {
  ACHFieldProps,
} from 'pages/Dashboard/pages/Billing/Payments/ACHPaymentField';

export type Part = 'root' | 'field';

type Props = {
  classes?: Partial<Record<Part, string>>;
};

const achFields: readonly ACHFieldProps[] = [{
  id: 'sender-account-number',
  name: 'insurancePayment.paymentMethod.senderAccountNumber',
  label: 'Sender Account Number',
}, {
  id: 'sender-routing-number',
  name: 'insurancePayment.paymentMethod.senderRoutingNumber',
  label: 'Sender Routing Number',
}, {
  id: 'receiver-account-number',
  name: 'insurancePayment.paymentMethod.receiverAccountNumber',
  label: 'Receiver Account Number',
}, {
  id: 'receiver-routing-number',
  name: 'insurancePayment.paymentMethod.receiverRoutingNumber',
  label: 'Receiver Routing Number',
}];

export default function ACHFields({
  classes,
}: Props) {
  return (
    <div className={clsx('flex flex-wrap gap-form-field w-full', classes?.root)}>
      {achFields.map((field) => (
        <ACHPaymentField
          key={field.id}
          {...field}
          className={clsx('w-full', classes?.field)}
        />
      ))}
    </div>
  );
}
